import { render, staticRenderFns } from "./InsuranceBridgeRecipeMedicForm.vue?vue&type=template&id=50a7b053&scoped=true&"
import script from "./InsuranceBridgeRecipeMedicForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeRecipeMedicForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceBridgeRecipeMedicForm.vue?vue&type=style&index=0&id=50a7b053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7b053",
  null
  
)

export default component.exports